import {
  CLOSE_ALL_MODALS,
  CLOSE_DISCLAIMER,
  CLOSE_MODAL,
  FLIP_BIKE,
  GO_TO_NEXT_STEP,
  GO_TO_PREV_STEP,
  OPEN_DISCLAIMER,
  OPEN_MODAL,
  PREVIEW_ACCESSORY,
  RESET_CONFIGURATOR,
  SET_ACCESSORIES_CATEGORY,
  SET_ACCESSORIES_PAGE,
  SET_ACCESSORIES_QUERY,
  SET_ACCESSORIES_SORT,
  SET_ACCESSORY_CATEGORIES,
  SET_ACCESSORY_EXTRAS,
  SET_ACCESSORY_ITEMS,
  SET_MODAL_PROPS,
  SET_PACKS,
  SET_PRINT_ACTIONS,
  SET_SCROLL_X_POSITION,
  SET_SCROLL_Y_POSITION,
  SET_SELECTED_DISCLAIMER,
  SET_STEP,
  TOGGLE_FULLSCREEN,
  TOGGLE_SIDE,
  ZOOM_OFF,
  ZOOM_ON,
} from './types';

export const setStep = payload => ({
  type: SET_STEP,
  payload,
});

export const goToPrevStep = () => ({
  type: GO_TO_PREV_STEP,
});

export const goToNextStep = () => ({
  type: GO_TO_NEXT_STEP,
});

export const toggleSide = () => ({
  type: TOGGLE_SIDE,
});

export const toggleFullscreen = () => ({
  type: TOGGLE_FULLSCREEN,
});

export const setAccessoriesCategory = payload => ({
  type: SET_ACCESSORIES_CATEGORY,
  payload,
});

export const setAccessoriesSort = payload => ({
  type: SET_ACCESSORIES_SORT,
  payload,
});

export const setAccessoriesQuery = payload => ({
  type: SET_ACCESSORIES_QUERY,
  payload,
});

export const setAccessoriesPage = payload => ({
  type: SET_ACCESSORIES_PAGE,
  payload,
});

export const setModalProps = (modalName, props) => ({
  type: SET_MODAL_PROPS,
  payload: {
    modalName,
    props,
  },
});

export const openModal = (modalName, props) => ({
  type: OPEN_MODAL,
  payload: {
    modalName,
    props,
  },
});

export const closeModal = (name, clearProps = true) => ({
  type: CLOSE_MODAL,
  payload: {
    name,
    clearProps,
  },
});

export const openDisclaimer = payload => ({
  type: OPEN_DISCLAIMER,
  payload,
});

export const closeDisclaimer = payload => ({
  type: CLOSE_DISCLAIMER,
  payload,
});

export const setSelectedDisclaimer = payload => ({
  type: SET_SELECTED_DISCLAIMER,
  payload,
});

export const resetConfigurator = payload => ({
  type: RESET_CONFIGURATOR,
  payload,
});

export const setAccessoryItems = payload => ({
  type: SET_ACCESSORY_ITEMS,
  payload,
});

export const setAccessoryCategories = payload => ({
  type: SET_ACCESSORY_CATEGORIES,
  payload,
});

export const setAccessoryExtras = payload => ({
  type: SET_ACCESSORY_EXTRAS,
  payload,
});

export const previewAccessory = payload => ({
  type: PREVIEW_ACCESSORY,
  payload,
});

export const flipBike = () => ({
  type: FLIP_BIKE,
});

export const closeAllModals = () => ({
  type: CLOSE_ALL_MODALS,
});

export const zoomOn = () => ({
  type: ZOOM_ON,
});

export const zoomOff = () => ({
  type: ZOOM_OFF,
});

export const setScrollYPosition = payload => ({
  type: SET_SCROLL_Y_POSITION,
  payload,
});

export const setScrollXPosition = payload => ({
  type: SET_SCROLL_X_POSITION,
  payload,
});

export const setPacks = payload => ({
  type: SET_PACKS,
  payload,
});

export const setPrintActions = payload => ({
  type: SET_PRINT_ACTIONS,
  payload,
});
